export const calendly_link_en = "https://calendly.com/new-window-development/discovery-call";
